'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _events = require('./events');

var Events = _interopRequireWildcard(_events);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 */
var DeskproWindowFacade = function () {
  function DeskproWindowFacade(eventDispatcher) {
    (0, _classCallCheck3.default)(this, DeskproWindowFacade);

    this.props = { eventDispatcher: eventDispatcher };
  }

  /**
   * @method
   *
   * @param notification
   * @return Promise<null,null>
   */


  (0, _createClass3.default)(DeskproWindowFacade, [{
    key: 'showNotification',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(notification) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_DESKPROWINDOW_SHOW_NOTIFICATION, notification));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function showNotification(_x) {
        return _ref.apply(this, arguments);
      }

      return showNotification;
    }()

    /**
     * Inserts markup into a specific parent or document.body
     *
     * @method
     * 
     * @param {DOMInsertRequest} insertRequest the markup to insert
     * @return {Promise<String,Error>}
     */

  }, {
    key: 'domInsert',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(insertRequest) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_DESKPROWINDOW_DOM_INSERT, insertRequest));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function domInsert(_x2) {
        return _ref2.apply(this, arguments);
      }

      return domInsert;
    }()

    /**
     * @method
     *
     * @param {DOMQueryPattern|Array.<DOMQueryPattern>} query a
     * @return {Promise<Array<DOMQueryMatchExists|DOMQueryMatchValueOf>, Error>}
     */

  }, {
    key: 'domQuery',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(query) {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_DESKPROWINDOW_DOM_QUERY, query));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function domQuery(_x3) {
        return _ref3.apply(this, arguments);
      }

      return domQuery;
    }()
  }]);
  return DeskproWindowFacade;
}();

exports.default = DeskproWindowFacade;

/**
 * Representation of a DOM Insert Request
 *
 * @typedef {Object} DOMInsertRequest
 * @property {string} [parent] a parent DOM selector. Jquery selectors supported. If omitted, document.body is assumed
 * @property {string} markup the markup to insert
 */

/**
 * Representation of a DOM Query Pattern
 *
 * @typedef {Object} DOMQueryPattern
 * @property {'valueOf'|'exists'} type the type of selection, controls what will be returned in case of a match
 * @property {string} selector a selector string, see {@link  https://developer.mozilla.org/en-US/docs/Web/API/Document_object_model/Locating_DOM_elements_using_selectors}. jquery selectors also accepted
 */

/**
 * Represents the result of applying a DOM Query Pattern with a `valueOf` type
 *
 * @typedef {Object} DOMQueryMatchValueOf
 * @property {'valueOf'} type type the type of selection
 * @property {string} selector the original selector
 * @property {string} value the matched nodes
 */

/**
 * Represents the result of applying a DOM Query Pattern with a `exists` type
 *
 * @typedef {Object} DOMQueryMatchExists
 * @property {'exists'} type
 * @property {string} selector the original selector
 * @property {boolean} exists true if any dom nodes matched the original selector
 */


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/DeskproWindow/DeskproWindowFacade.js
// module id = 328
// module chunks = 0